import { useMutation } from '@tanstack/react-query';
import { fetchXmlDaNota, type XmlDaNotaFiltro, type XmlDaNotaResponse } from '../api/XmlDaNotaApi';

/** Mutação, e não consulta: o XML só é pedido no clique do "Baixar XML" (SPEC-018, §3, item 5). */
export function useXmlDaNota() {
  return useMutation<XmlDaNotaResponse, Error, XmlDaNotaFiltro>({
    mutationFn: fetchXmlDaNota,
  });
}
